import React from "react";
import { AiFillCloseCircle, AiOutlineDownload } from "react-icons/ai";

const ImageViewer = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;
  const fileName = imageUrl.split("/").pop() || "image.jpg";
  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="relative bg-white rounded-lg shadow-lg p-2 w-[90vw] h-[90vh] sm:w-[80vw] sm:h-[80vh] md:w-[70vw] md:h-[70vh] lg:w-[55vw] lg:h-[55vh] flex items-center justify-center">
        <div className="absolute top-2 right-2 flex gap-2 z-10">
          <a
            href={imageUrl}
            download={fileName}
            className="text-primary text-sm hover:text-primary/80 border border-primary rounded-lg px-2 py-1"
            title="Download Image"
          >
            <span className="flex flex-row items-center gap-2"> <AiOutlineDownload /> Download</span>
          </a>
          <button
            onClick={onClose}
            className="text-primary text-2xl"
            title="Close"
          >
            <AiFillCloseCircle />
          </button>
        </div>
        <img
          src={imageUrl}
          alt="Attachment Preview"
          className="max-w-[80vw] max-h-[80vh] sm:max-w-[70vw] sm:max-h-[70vh] md:max-w-[60vw] md:max-h-[60vh] lg:max-w-[45vw] lg:max-h-[45vh] rounded-lg shadow"
        />
      </div>
    </div>
  );
};

export default ImageViewer; 